import React, { useState, useEffect } from 'react';
import { useWhitelabelLogos, useWhitelabelBranding } from '../../../hooks/useWhitelabel';

const WhitelabelLogo = ({ type = 'main', alt, className = '', style = {}, fallback = null, ...props }) => {
  const logos = useWhitelabelLogos();
  const { brandName } = useWhitelabelBranding();
  const [imageError, setImageError] = useState(false);

  const getLogoUrl = () => {
    switch (type) {
      case 'main':
        return logos.main;
      case 'mobile':
        return logos.mobile || logos.main;
      case 'favicon':
        return logos.favicon;
      default:
        return logos.main;
    }
  };

  const logoUrl = getLogoUrl();
  const logoAlt = alt || `${brandName} Logo`;

  // Reset error state quando logoUrl mudar
  useEffect(() => {
    setImageError(false);
  }, [logoUrl]);

  // Se não há URL ou houve erro ao carregar, mostrar fallback
  if (!logoUrl || imageError) {
    if (fallback) {
      return fallback;
    }
    
    return (
      <div className={`whitelabel-logo-fallback ${className}`} style={style} {...props}>
        <span className="brand-text">{brandName}</span>
      </div>
    );
  }

  return (
    <img
      src={logoUrl}
      alt={logoAlt}
      className={`whitelabel-logo whitelabel-logo-${type} ${className}`}
      style={style}
      onError={(e) => {
        console.warn(`⚠️ Erro ao carregar logo whitelabel: ${logoUrl}`);
        // Usar estado React para renderizar o fallback
        setImageError(true);
        e.target.style.display = 'none';
      }}
      {...props}
    />
  );
};

export default WhitelabelLogo;